import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

// local short hand used for defining valid api calls routes
const GET = 'get';
const POST = 'post';
const FIND = 'find';
const PATCH = 'patch';
const REMOVE = 'remove';

@Injectable({
  providedIn: 'root'
})
export class RoutesService {

  constructor(
    private auth: AuthService,
  ) { }

  currentHost(){
    return 'https://mathproficiencytest.ca/'
  }

  ANALYTICS_SESSION                                  = 'rest/analytics/session';
  ANALYTICS_EVENT                                    = 'rest/analytics/event';
  AUTH_TEST_TAKER                                    = 'rest/auth/test-taker';
  AUTH_TEST_ADMIN                                    = 'rest/auth/test-admin';
  AUTH_TEST_CTRL                                     = 'rest/auth/test-ctrl';
  AUTH_TEST_CERT                                     = 'rest/auth/test-cert';
  TEST_ADMIN_INSTITUTION                             = 'rest/test-admin/institution';
  TEST_ADMIN_TEST_SESSION_SETUP_ACTIVE               = 'rest/test-admin/test-session-setup/active';
  TEST_ADMIN_TEST_SESSION_SETUP_CHECKLIST            = 'rest/test-admin/test-session-setup/checklist';
  TEST_ADMIN_TEST_SESSION_SETUP_TEST_WINDOWS         = 'rest/test-admin/test-session-setup/test-windows';
  TEST_ADMIN_TEST_SESSION_SETUP_LOCATIONS            = 'rest/test-admin/test-session-setup/locations';
  TEST_ADMIN_TEST_SESSION_SETUP_ACCOMM_PING          = '/rest/test-admin/test-session-setup/accomm-ping';
  TEST_ADMIN_TEST_SESSION_SETUP_TECH_READY           = 'rest/test-admin/test-session-setup/tech-ready';
  TEST_ADMIN_TEST_SESSION_SETUP_TIME_SLOTS           = 'rest/test-admin/test-session-setup/time-slots';
  TEST_ADMIN_TEST_SESSION_SETUP_TIME_SLOT_RESTRICTION= 'rest/test-admin/test-session-setup/time-slot-restriction';
  TEST_ADMIN_TEST_SESSION_SETUP_SESSIONS             = 'rest/test-admin/test-session-setup/sessions';
  TEST_ADMIN_TEST_SESSIONS_MY_UPCOMING               = 'rest/test-admin/test-sessions/my-upcoming';
  TEST_ADMIN_TEST_SESSIONS_ALL                       = 'rest/test-admin/test-sessions/all';
  TEST_ADMIN_TEST_SESSIONS_SUMMARY                   = 'rest/test-admin/test-sessions/summary';
  TEST_ADMIN_TEST_SESSION_CANCELLATION               = 'rest/test-admin/test-session/cancellation';
  TEST_ADMIN_TEST_SESSION_RESTRICTIONS               = 'rest/test-admin/test-session/restrictions';
  TEST_ADMIN_TEST_SESSION_STATUS_UPDATE              = 'rest/test-admin/test-session/status-update';
  TEST_ADMIN_TEST_SESSION_ASSIGNED_INVIGILATOR       = 'rest/test-admin/test-session/assigned-invigilator';
  TEST_ADMIN_TEST_SESSION_INVITATION_CODE            = 'rest/test-admin/test-session/invitation-code';
  TEST_ADMIN_TEST_SESSION_CAPACITY                   = 'rest/test-admin/test-session/capacity';
  TEST_ADMIN_TEST_SESSION_BOOKINGS                   = 'rest/test-admin/test-session/bookings';
  TEST_ADMIN_TEST_SESSION_WAITLISTERS                = 'rest/test-admin/test-session/waitlisters';
  TEST_ADMIN_TEST_SESSION_BOOKING_TRANSFER_REQ       = 'rest/test-admin/test-session/booking-transfer-req';
  TEST_ADMIN_TEST_SESSION_WAITLISTER_TRANSFER_REQ    = 'rest/test-admin/test-session/waitlister-transfer-req';
  TEST_ADMIN_TEST_SESSION_BOOKINGS_INDIC             = 'rest/test-admin/test-session/bookings-indic';
  TEST_ADMIN_TEST_SESSION_WAIT_LISTINGS_INDIC        = 'rest/test-admin/test-session/wait-listings-indic';
  TEST_ADMIN_ACCOUNTS_ACCESS                         = 'rest/test-admin/accounts/access';
  TEST_ADMIN_ACCOUNTS_ASSIGNED_COORD                 = 'rest/test-admin/accounts/assigned-coord';
  TEST_ADMIN_ACCOUNTS_ASSIGNED_SESSIONS              = 'rest/test-admin/accounts/assigned-sessions';
  TEST_ADMIN_ACCOMM_PENDING_REQUESTS                 = 'rest/test-admin/accomm/pending-requests';
  TEST_ADMIN_ACCOMM_TRANSFER_REQ                     = 'rest/test-admin/accomm/transfer-req';
  TEST_ADMIN_INVIGILATION_                           = 'rest/test-admin/invigilation/';
  TEST_ADMIN_INVIGILATION_PAUSE                      = 'rest/test-admin/invigilation/pause';
  TEST_ADMIN_INVIGILATION_CLOSE                      = 'rest/test-admin/invigilation/close';
  TEST_ADMIN_INVIGILATION_SEND                       = 'rest/test-admin/invigilation/send';
  TEST_ADMIN_INVIGILATION_GROUP_ISSUE                = 'rest/test-admin/invigilation/group-issue';
  TEST_ADMIN_INVIGILATION_INDIV_ISSUE                = 'rest/test-admin/invigilation/indiv-issue';
  TEST_ADMIN_INVIGILATION_GROUP_TIME_EXTEND          = 'rest/test-admin/invigilation/group-time-extend';
  TEST_ADMIN_INVIGILATION_INDIV_TIME_EXTEND          = 'rest/test-admin/invigilation/indiv-time-extend';
  TEST_ADMIN_INVIGILATION_IDENTITY_VERIF             = 'rest/test-admin/invigilation/identity-verif';
  TEST_ADMIN_INVIGILATION_IDENTITY_NO                = 'rest/test-admin/invigilation/identity-no';
  TEST_ADMIN_INVIGILATION_ABSENCE_REPORT             = 'rest/test-admin/invigilation/absence-report';
  TEST_ADMIN_INVIGILATION_TEMP_ACCESS                = 'rest/test-admin/invigilation/temp-access';
  TEST_TAKER_TEST_SESSIONS_ALL                       = 'rest/test-taker/test-sessions/all';
  TEST_TAKER_TEST_SESSIONS_BOOKING                   = 'rest/test-taker/test-sessions/booking';
  TEST_TAKER_TEST_SESSIONS_WAITLIST                  = 'rest/test-taker/test-sessions/waitlist';
  TEST_TAKER_TEST_SESSIONS_PAST_ATTEMPTS             = 'rest/test-taker/test-sessions/past-attempts';
  TEST_TAKER_ACCOMMODATIONS_PENDING_REQ              = 'rest/test-taker/accommodations/pending-req';
  TEST_TAKER_INVIGILATION_TEST_ATTEMPT               = 'rest/test-taker/invigilation/test-attempt';
  TEST_TAKER_INVIGILATION_SCREEN_SESSION             = 'rest/test-taker/invigilation/screen-session';
  TEST_TAKER_INVIGILATION_TEST_FORM                  = 'rest/test-taker/invigilation/test-form';
  TEST_TAKER_INVIGILATION_QUESTION_CONTENT           = 'rest/test-taker/invigilation/question-content';
  TEST_TAKER_INVIGILATION_QUESTION_RESPONSE          = 'rest/test-taker/invigilation/question-response';
  TEST_TAKER_INVIGILATION_SECTION_SUBMIT             = 'rest/test-taker/invigilation/section-submit';
  TEST_CTRL_SUMMARY                                  = 'rest/test-ctrl/summary';
  TEST_CTRL_TEST_WINDOW_NAME                         = 'rest/test-ctrl/test-window/name';
  TEST_CTRL_TEST_WINDOW_PUBLISH                      = 'rest/test-ctrl/test-window/publish';
  TEST_CTRL_TEST_WINDOW_RELEASE_NOTES                = 'rest/test-ctrl/test-window/release-notes';
  TEST_CTRL_TEST_WINDOW_RETRIEVALS                   = 'rest/test-ctrl/test-window/retrievals';
  TEST_CTRL_TEST_WINDOW_EARLY_RELEASE                = 'rest/test-ctrl/test-window/early-release';
  TEST_CTRL_TEST_WINDOW_TEST_SESSIONS                = 'rest/test-ctrl/test-window/test-sessions';
  TEST_CTRL_TEST_WINDOW_TEST_DESIGN                  = 'rest/test-ctrl/test-window/test-design';
  TEST_CTRL_TEST_WINDOW_DATE_FROM                    = 'rest/test-ctrl/test-window/date_from';
  TEST_CTRL_TEST_WINDOW_DATE_TO                      = 'rest/test-ctrl/test-window/date_to';
  TEST_CTRL_ACCOUNTS_TEST_ADMINS                     = 'rest/test-ctrl/accounts/test-admins';
  TEST_CTRL_ACCOUNTS_TEST_CERTS                      = 'rest/test-ctrl/accounts/test-certs';
  TEST_CTRL_ACCOUNTS_TEST_CTRLS                      = 'rest/test-ctrl/accounts/test-ctrls';
  TEST_CTRL_ACCOUNTS_ACCESS                          = 'rest/test-ctrl/accounts/access';
  TEST_CTRL_ACCOUNTS_ROLES                           = 'rest/test-ctrl/accounts/roles';
  TEST_CERT_RETRIEVALS                               = 'rest/test-cert/retrievals';
}
